export default __webpack_public_path__ + "static/media/info.6025711c.svg";